export const GantSizeColumns = [
    "Size",
    "MovexSize",
  ]


  